import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
}

export default function ModalBox({ children }: IProps) {
  return (
    <div
      style={{
        background:
          'linear-gradient(135deg, transparent 5%, #FFDA68 calc(1%), #FFDA68 95%, transparent 5px)',
      }}
      className='w-52 h-12 lg:h-20 p-[1px]'
    >
      <div
        style={{
          background:
            'linear-gradient(135deg, transparent 5%, #191919 calc(1%), #191919 95%, transparent 5px)',
        }}
        className='w-full h-full flex flex-col items-center justify-center text-base lg:text-[22px] leading-5 lg:leading-6'
      >
        {children}
      </div>
    </div>
  );
}
